import actionTypes from '../constants/action-types';

const setColorPaletteConfig = (config) => ({
  type: actionTypes.SET_COLOR_PALETTE_CONFIG,
  payload: {
    config,
  },
});

export default setColorPaletteConfig;
